import { chatHighlights } from "@/mocks/community";
import Avatar from "./Avatar";

const topicTags = ["翻车现场", "神仙操作", "脑洞大开", "名场面", "冷知识", "真香定律", "爷青回", "意难平", "宝藏发现", "理性讨论", "集美视角", "大瓜预警"];

export default function Digest() {
  return (
    <section id="digest" className="w-full bg-background-100/60">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16 w-full">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-3">
          <div>
            <p className="inline-flex items-center gap-2 text-xs font-semibold tracking-wider text-primary-600 uppercase">
              <span className="w-6 h-px bg-primary-500" aria-hidden="true"></span> 实时互动
            </p>
            <h2 className="mt-2 text-2xl md:text-3xl font-black text-foreground-950">群聊精华 · 大家在说什么</h2>
            <p className="mt-2 text-sm text-foreground-600 max-w-2xl">
              每场爆款群聊的高光发言都被编辑部整理成精华，没来得及爬楼也能一眼看明白。
            </p>
          </div>
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold self-start">
            <span className="relative flex w-2 h-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-accent-500 opacity-75"></span>
              <span className="relative inline-flex rounded-full w-2 h-2 bg-accent-500"></span>
            </span>
            <span className="whitespace-nowrap">当前 328 人在线群聊</span>
          </span>
        </div>

        <div className="mt-8 grid grid-cols-1 lg:grid-cols-3 gap-6 items-start">
          <div className="lg:col-span-2 space-y-3">
            {chatHighlights.map((c, i) => (
              <div
                key={c.who}
                className="rounded-2xl bg-background-50 border border-background-200 p-4 flex items-start gap-3"
              >
                <Avatar char={c.who.charAt(0)} tone={c.tone} size="w-10 h-10 text-base" />
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-2">
                    <span className="text-sm font-bold text-foreground-900">{c.who}</span>
                    <span className="text-[11px] text-foreground-400">发表于今日 {18 - i}:{30 - i * 4}</span>
                    <span className="text-[11px] px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 font-semibold">群聊精选</span>
                  </div>
                  <p className="mt-1.5 text-sm text-foreground-700 leading-relaxed">{c.text}</p>
                </div>
              </div>
            ))}

            <a
              href="#join"
              className="flex items-center justify-center gap-2 w-full py-3 rounded-2xl bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-semibold transition-colors"
            >
              <i className="ri-chat-smile-line text-lg" aria-hidden="true"></i> 进入群聊，加入实时讨论
            </a>
          </div>

          <aside className="lg:col-span-1 rounded-2xl bg-background-50 border border-background-200 p-5">
            <h3 className="text-sm font-bold text-foreground-900 flex items-center gap-2">
              <i className="ri-price-tag-3-line text-primary-500" aria-hidden="true"></i> 热门话题标签
            </h3>
            <div className="mt-4 flex flex-wrap gap-2">
              {topicTags.map((t) => (
                <a
                  key={t}
                  href="#board"
                  className="px-3 py-1.5 rounded-full bg-background-100 border border-background-200 text-foreground-600 hover:border-primary-300 hover:text-primary-600 text-xs whitespace-nowrap transition-colors"
                >
                  #{t}
                </a>
              ))}
            </div>
            <div className="mt-5 rounded-xl bg-gradient-to-br from-primary-100 to-accent-100 p-4">
              <p className="text-sm font-bold text-foreground-900">还没想好聊什么？</p>
              <p className="mt-1 text-xs text-foreground-700 leading-relaxed">
                跟着热搜话题走，或者发起你自己的话题，等同样好奇的瓜友来报到。
              </p>
              <a
                href="#join"
                className="mt-3 inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-foreground-950 hover:bg-foreground-800 text-background-50 text-xs font-semibold whitespace-nowrap transition-colors"
              >
                <i className="ri-lightbulb-flash-line" aria-hidden="true"></i> 发起话题
              </a>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}